import { createContext, useContext, useState, useMemo } from "react";

const BookingContext = createContext(null);

const emptyBooking = {
  collectionId: null,
  size: null,
  addons: {},
  priorityRemoval: false,
  removalDate: "",
  customColors: {},
  palette: { colors: [], balance: "equal", primary: "", accent: "" },
  extraPumpkins: 0,
  mumColors: {},
  mumColorOther: "",
  customerNotes: "",
  referredBy: "",
  date: null,
  timeSlot: null,
  firstName: "",
  lastName: "",
  email: "",
  phone: "",
  street: "",
  city: "",
  state: "",
  zip: "",
  photoBase64: null,
  photoConsent: false,
  isGift: false,
  recipientName: "",
  giftMessage: "",
};

export const BookingProvider = ({ children }) => {
  const [booking, setBooking] = useState(emptyBooking);
  const update = (patch) => setBooking((b) => ({ ...b, ...patch }));
  const reset = () => setBooking(emptyBooking);
  const value = useMemo(() => ({ booking, update, reset }), [booking]);
  return <BookingContext.Provider value={value}>{children}</BookingContext.Provider>;
};

export const useBooking = () => {
  const ctx = useContext(BookingContext);
  if (!ctx) throw new Error("useBooking must be used inside BookingProvider");
  return ctx;
};
